module.exports = __webpack_public_path__ + "img/header-video-bg.5fadfede.jpg";